"use client";

import type { TestimonialItem } from "@/components/landing/Testimonials/types";
import {
	FallbackImage,
	MotionReveal,
	SectionHeader,
	useSectionMotion,
} from "@/components/landing/shared";
import AvatarInitials from "@/components/landing/Testimonials/AvatarInitials";

interface TestimonialsInnerProps {
	title: string;
	items: TestimonialItem[];
}

function TestimonialsInner(prop: TestimonialsInnerProps) {
	const { title, items } = prop;
	const motion = useSectionMotion();
	return (
		<div className="mx-auto max-w-6xl px-6">
			<MotionReveal motion={motion}>
				<SectionHeader
					title={title}
					titleClassName="mb-12 text-center text-3xl font-bold tracking-tight sm:text-4xl"
				/>
			</MotionReveal>
			<div className="grid gap-5 md:grid-cols-3">
				{items.map((item, i) => (
					<MotionReveal motion={motion} delayOffset={i * 80} key={`${item.name}-${i}`}>
						<figure className="card h-full p-6">
							<blockquote className="text-lg leading-relaxed">
								&ldquo;
								{item.quote}
								&rdquo;
							</blockquote>
							<figcaption className="mt-6 flex items-center gap-3">
								{item.avatar ? (
									<FallbackImage
										src={item.avatar}
										alt={item.name}
										className="h-12 w-12 rounded-full object-cover"
										fallback={<AvatarInitials name={item.name} />}
									/>
								) : (
									<AvatarInitials name={item.name} />
								)}
								<span>
									<span className="block font-semibold">{item.name}</span>
									<span className="block text-sm text-muted-foreground">{item.role}</span>
								</span>
							</figcaption>
						</figure>
					</MotionReveal>
				))}
			</div>
		</div>
	);
}

export default TestimonialsInner;
